import {idlAPIClient} from "./axios";
import {AxiosResponse} from "axios";

const emailDocument = async (data: any):Promise<any> => {
  const response:AxiosResponse<any, any> = await idlAPIClient.post<any>(
    'email/sendmail',
    data);
  return response.data;
}

const emailReportIssue = async (data: any):Promise<any> => {
  const response:AxiosResponse<any, any> = await idlAPIClient.post<any>(
    'reportissue',
    data);
  return response.data;
}

const EmailService = {
  emailDocument,
  emailReportIssue
}

export default EmailService;
